export default {"src":"/_next/static/media/urgent-zh-leave-icon.2d056ad2.svg","height":48,"width":48};